import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { AuthShell } from "@/components/AuthShell";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { api, formatApiErrorDetail } from "@/lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  if (sent) {
    return (
      <AuthShell
        testid="forgot-sent-card"
        title="Controlla la tua e-mail"
        subtitle="Se l’indirizzo è registrato, riceverai un link per reimpostare la password."
      >
        <Link data-testid="forgot-to-login-link" to="/login" className="block text-center text-[#c85f45] font-semibold text-sm">
          Torna al login
        </Link>
      </AuthShell>
    );
  }

  return (
    <AuthShell testid="forgot-card" title="Password dimenticata" subtitle="Ti invieremo un link sicuro di reset.">
      <form onSubmit={submit} className="flex flex-col gap-4">
        <div className="flex flex-col gap-1.5">
          <Label htmlFor="email">E-mail</Label>
          <Input
            id="email"
            data-testid="forgot-email-input"
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>
        <Button
          type="submit"
          data-testid="forgot-submit-btn"
          disabled={loading}
          className="w-full bg-[#e8836b] hover:bg-[#d76f57] text-white rounded-full py-6 text-sm font-semibold disabled:opacity-50"
        >
          {loading ? "Invio…" : "INVIA LINK DI RESET"}
        </Button>
      </form>
    </AuthShell>
  );
}
